import { createContext, useContext, useCallback } from 'react';

const CaptureModalContext = createContext(null);

// "New Capture" opens the full capture page in a NEW browser window so users can
// keep browsing Milk while they record. Recording auto-starts (mode=record).
export function CaptureModalProvider({ children }) {
  const openModal = useCallback((mode = 'record') => {
    window.open(`/capture${mode ? `?mode=${mode}` : ''}`, '_blank', 'noopener');
  }, []);
  const closeModal = useCallback(() => {}, []);
  return (
    <CaptureModalContext.Provider value={{ open: false, openModal, closeModal }}>
      {children}
    </CaptureModalContext.Provider>
  );
}

export function useCaptureModal() {
  const ctx = useContext(CaptureModalContext);
  if (!ctx) throw new Error('useCaptureModal must be used within CaptureModalProvider');
  return ctx;
}
